var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlastPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 60,
    viewBox: "0 0 91 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8399 48.5182L30.7819 20.6682L20.8629 13.2412L5.96094 60.0002H61.4659L65.1789 48.5182H21.8399Z",
    fill: "#FCFC03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.53 29.463L85.847 22.329L90.782 7.182L80.912 0H15.195L0 11.287H77.248L73.143 23.99H42.166L39.186 33.274H70.163L61.466 60L75.977 52.818L81.156 36.792L71.433 29.658L71.53 29.463Z",
    fill: "#FCFC03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlastPoint);
export default __webpack_public_path__ + "static/media/blast-point.c0c40bbff2be7b4e0a7705e13f2b2aa0.svg";
export { ForwardRef as ReactComponent };